/**
 * EVO — agent faoliyati hisobotining URL holati.
 *
 * `lib/report-search.ts` bilan bir xil qoidalar (davr tozalanadi, default
 * URL ga yozilmaydi). Alohida fayl, chunki `lib/agent-activity.ts` ham
 * alohida: hisobot hozircha `reports` moduli tashqarisida va uning javob
 * shakli boshqacha. Server metodni `ReportsService` ga ko'chirgan kuni
 * ikkalasi ham o'z joyiga qo'shiladi.
 *
 * Davrni tozalash `parsePeriodSearch` dan QAYTA YOZILMAYDI — o'sha funksiya
 * to'g'ridan-to'g'ri ishlatiladi: davr qoidasi (ikkalasi ham bo'lishi shart,
 * aks holda default oy) barcha hisobotlarda bir xil bo'lishi kerak.
 */
import { parsePeriodSearch, type PeriodSearch } from './report-search';

export interface AgentActivitySearch extends PeriodSearch {
  /**
   * Bitta xodimga chuqurlashish.
   *
   * Ro'yxat SERVERDAN kelgan satrlardan quriladi, xodimlar ma'lumotnomasidan
   * emas (`routes/reports/agent-activity.tsx` dagi izoh). Shuning uchun bu
   * yerda faqat «musbat butun son» tekshiriladi: begona ID bo'lsa hisobot
   * bo'sh qaytadi, xato bermaydi.
   */
  readonly agentId?: number;
}

export function parseAgentActivitySearch(
  search: Record<string, unknown>,
): AgentActivitySearch {
  const agentId = Number(search.agentId);

  return {
    ...parsePeriodSearch(search),
    ...(Number.isInteger(agentId) && agentId > 0 ? { agentId } : {}),
  };
}
